import Portfolio from './portfolio-2023/Portfolio';

function App() {
  return <Portfolio />;
}

export default App;
